<template>
  <div
    id="shareModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="shareModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            id="shareModalLabel"
            class="modal-title"
          >
            Share Preview
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div
            v-if="isGeneratingShareLink"
            class="text-center"
          >
            <div
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">
              Generating share link...
            </p>
          </div>
          <div
            v-else
            class="form-group"
          >
            <label for="share-link">Share Link</label>
            <div class="input-group">
              <input
                id="share-link"
                v-model="shareLink"
                type="text"
                class="form-control"
                readonly
              >
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  @click="copyShareLink"
                >
                  <i class="fas fa-copy" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WalmartShareModal',
  props: {
    creativeId: {
      type: [String, Number, null],
      default: null
    },
    platformId: {
      type: [String, Number, null],
      default: null
    },
    companyId: {
      type: [String, Number, null],
      default: null
    }
  },
  data() {
    return {
      shareLink: '',
      isGeneratingShareLink: false
    }
  },
  methods: {
    show() {
      this.generateShareLink();
      $('#shareModal').modal('show');
    },

    async generateShareLink() {
      this.isGeneratingShareLink = true;

      try {
        const { data } = await axios.post('/walmart/generate-share-link', {
          creative_id: this.creativeId,
          platform_id: this.platformId,
          company_id: this.companyId
        });

        if (data && data.share_url) {
          this.shareLink = data.share_url;
        } else {
          toastr.error('Failed to generate share link');
        }
      } catch (error) {
        console.error('Error generating share link:', error);
        toastr.error('Failed to generate share link');
      } finally {
        this.isGeneratingShareLink = false;
      }
    },

    copyShareLink() {
      navigator.clipboard.writeText(this.shareLink);

      toastr.success('Share link copied');
    }
  }
}
</script>
